export const enum AcceptanceErrorTypeCode {
    ABSOLUTE = "ABS",
    PERCENTAGE = "%",
}
